(function ($) {
	"use strict";

	$(".detail-navigation").on("click",function(e) {
		var link = $(this).data("link");
		window.location = link;
	});


	$("[data-show-toolhistory-edit]").on("click",
		function (e) {
			e.preventDefault();
			e.stopPropagation();

			var toolhistoryListItem = $(this).parents("li");

			if (toolhistoryListItem.find('[data-edit-notes-form]').hasClass("d-none")) {
				toolhistoryListItem.find('[data-show-comment]').hide();
				toolhistoryListItem.find('[data-edit-notes-form]').show();
			} else {
				toolhistoryListItem.find('[data-show-comment]').show();
				toolhistoryListItem.find('[data-edit-notes-form]').hide();
			}

		});

	$(window).click(function (e) {
		if ($(e.target).closest("[data-edit-notes-form]").length <= 0) {
			$('[data-show-comment]').show();
			$("[data-edit-notes-form]").hide();
		}
	}.bind(this));

	$("[data-delete-toolhistorynote]").on("click",
		function (e) {
			e.preventDefault();
			e.stopPropagation();

			var toolhistoryListItem = $(this).parents("li");

			toastr["warning"](toolhistoryListItem.find('[data-reset-tool-historynote]').html());

		});


	})(jQuery);
